module.exports = __webpack_public_path__ + "static/media/icon_location.50e27788.svg";